import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import type { optionType, Translationtype } from "utils";

interface IFormReactSelectProps {
  setValue?: any;
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  name: string;
  title: string;
  tooltip?: string;
  t: Translationtype;
  control: any;
  initialPlaceHolder?: string;
  disableClear?: boolean;
  options: optionType[];
  isMulti?: boolean;
}

export function FormReactSelect({
  errors,
  className,
  name,
  title,
  options,
  t,
  control,
  disableClear,
  disabled,
  isMulti = false,
}: IFormReactSelectProps) {
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="w-full block mb-1 text-textColor">
        {title}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ReactSelect
            {...field}
            unstyled
            classNames={{
              control: ({ isDisabled, isFocused }) =>
                `input w-full min-h-[48px] px-4 ${
                  isDisabled ? "!bg-gray-200" : ""
                } ${isFocused ? "!border-2 !border-borderColor/40" : ""}`,
              valueContainer: () => "p-0",
              input: () => "m-0 p-0",
              indicatorsContainer: () => "h-[48px]",
              menu: () =>
                "z-[9999] mt-1 rounded-2xl border border-gray-200 bg-white shadow-md",
              option: ({ isFocused, isSelected }) =>
                `px-4 py-2 cursor-pointer ${
                  isSelected ? "bg-gray-100" : ""
                } ${isFocused ? "bg-gray-50" : ""}`,
            }}
            value={field.value}
            options={options}
            isMulti={isMulti}
            isClearable={!disableClear}
            isDisabled={disabled}
          />
        )}
      />

      {errors[name]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[name]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
